"use strict";

exports.__esModule = true;
exports.EditPrioritySection = EditPrioritySection;
var _react = _interopRequireDefault(require("react"));
var _FormGroupField = require("../../Form/FormGroupField");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _TicketTypeSelector = require("../../Logbook/TicketTypeSelector");
var _getTranslatedTicketPriorities = require("../getTranslatedTicketPriorities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function EditPrioritySection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var style = props.style;
  var priorities = (0, _getTranslatedTicketPriorities.getTranslatedTicketPriorities)(translate);
  function validateTypes(value) {
    if (!value || value.length === 0) {
      return translate("TicketDetailsEditForm.priorityError", "Priority is required.");
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("TicketDetailsEditForm.Priority", "Priority"),
    content: /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "priority",
      validate: validateTypes,
      style: style
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeSelector.TicketTypeSelector, {
        minimal: true,
        items: priorities,
        selected: [priorities.find(function (_ref2) {
          var id = _ref2.id;
          return input.value === id;
        })],
        onSelect: function onSelect(_ref3) {
          var _ = _ref3[0],
            v = _ref3[1];
          return input.onChange(v.id);
        },
        dataTestId: "TicketPrioritySelector"
      });
    })
  });
}